<style>

#declarations_card {
    width: 95%;
    align-self: center;
}

.notification_dialog {
    max-width: 60%;
}

.cc_add_button {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 30%;
    align-self: center;
}

</style>

<template>
    <template>
        <v-dialog v-model="show" class="notification_dialog" @click:outside="cancelNotification">
            <v-card>
                <v-card-title>Notifica errori del contenzioso/revisione: <b>{{ selected_item.number }}</b> del <b>{{ selected_item.creation_date }}</b></v-card-title>
                <v-card-text v-if="selected_item.declarations && selected_item.declarations.length > 0">La notifica verrà inviata solo agli utenti delle dichiarazioni riconosciute.<br>
                Le altre dichiarazioni verranno ignorate.
                </v-card-text>
                <v-card-text v-else>Non ci sono dichiarazioni associate a questo contenzioso/revisione.</v-card-text>
                
                <v-card id="declarations_card" v-if="selected_item.declarations && selected_item.declarations.length > 0">
                    <v-card-title>Dichiarazioni</v-card-title>
                    <v-data-table v-if="selected_item.declarations"
                    :headers="headers_declarations"
                    v-model="selectedDeclarations"
                    :items="selected_item.declarations"
                    :items-per-page-text="'Elementi per pagina: '"
                    :page-text="`Da {0} a {1} di {2} elementi`"
                    item-value="origin_id"
                    :value="selectedDeclarations"
                    show-select
                    >  
                    </v-data-table>
                </v-card>

                <v-row justify="center" v-for="(email, index) in email_cc" :key="index">
                    <v-col cols="auto">
                        <v-text-field
                            v-model="email_cc[index]"
                            label="Cc"
                            class="mr-2"
                            style="width: 500px"
                            :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn @click="removeEmailCC(index)" icon>
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-btn @click="addEmailCC" class="cc_add_button" v-if="selected_item.declarations && selected_item.declarations.length > 0">
                    Aggiungi email in Cc
                </v-btn>
                 
               <v-card-actions v-if="selected_item.declarations && selected_item.declarations.length > 0">
                    <v-btn @click="cancelNotification">Annulla</v-btn>
                    <v-btn @click="confirmNotificationSend(selected_item.id)">Invia</v-btn>
               </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <!-- SNACKBAR FOR ON-DISPLAY MESSAGES -->
        <snackbarTemplate ref="snackbar" />
    </template> 

</template>

<script>
    import axios from 'axios';
    import snackbarTemplate from './Snackbar.vue'

    export default {
        name: 'confirmErrorNotificationDialog',
        data() {
            return {
                show: false,
                selected_item: null,
                headers_declarations: [
                    { title: 'MRN', value: 'mrn'},
                    { title: 'Data Registrazione', value: 'registration_date'},
                    { title: 'Rettifica', value: 'is_revision'},
                    { title: 'Tipo', value: 'category_code'},
                    { title: 'Pratica', value: 'internal_reference'},
                    { title: 'Sezione Doganale', value: 'customs_office_code'},
                    { title: 'Utente', value: 'username'},
                ],
                email_cc: [],
                emailRules: [
                    v => !!v || 'Inserisci un indirizzo email',
                    v => /.+@.+\..+/.test(v) || 'Indirizzo email non valido'
                ],
                selectedDeclarations: []
            } 
        },
        updated() {
            this.selectedDeclarations = (this.selected_item.declarations ? this.selected_item.declarations.map(declaration => declaration.origin_id) : []);   
         },
        methods: {
            cancelNotification() {
                this.show = false;
                this.email_cc = [];
            },
            confirmNotificationSend(litigation_id) {
                console.log('Invio della notifica in corso...');
                const filtered_declarations = this.selected_item.declarations.filter(declaration => this.selectedDeclarations.includes(declaration.origin_id))

                const request_data = {
                    email_cc: this.email_cc,
                    declarations: filtered_declarations,
                    forced_email_address: null
                };

                if (process.env.VUE_APP_FORCE_NOTIFICATION_EMAIL == 'true') {
                    request_data.forced_email_address = process.env.VUE_APP_FORCE_NOTIFICATION_EMAIL_ADDRESS;
                }
                axios.post(`/api/litigations/${litigation_id}/send_notification/`, request_data)
                .then(response => {
                    console.log('Notifica inviata: ', response);
                    this.show = false;
                    this.$refs.snackbar.snackbar_message = 'Notifica inviata con successo';
                    this.$refs.snackbar.snackbar_style = 'success';
                    this.$refs.snackbar.show = true;
                })
                .catch(error => {
                    console.error(error);
                    this.show = false;
                    this.$refs.snackbar.snackbar_message = error.response.data.error;
                    this.$refs.snackbar.snackbar_style = 'error';
                    this.$refs.snackbar.show = true;
                })
                .finally(() => this.$emit('notification-sent'));
            },
            addEmailCC() {
                this.email_cc.push('');
            },
            removeEmailCC(index) {
                this.email_cc.splice(index, 1);
            },
        },
        components: {
            snackbarTemplate
        },
    }
</script>